<template>
  <div>
    <search-items
      placeholder="Search users - Hint: If the user does not show up (deleted for example), just enter the ID and press enter."
      :select-item="selectUser"
      :get-items="searchUsers"
      :type="'users'"
      :search-length="1"
      :on-enter="onEnter"
    />

    <template
      v-if="documents === null"
    >
      <v-alert
        :value="true"
        type="info"
      >
        Please choose a user first
      </v-alert>
    </template>
    <template
      v-else-if="documents.length === 0"
    >
      <v-alert
        :value="true"
        type="warning"
      >
        No documents for user "{{ user.id }}" found!
      </v-alert>
    </template>
    <template
      v-else
    >
      <div>
        User ID: {{ user.id }}
      </div>
      <v-card-title>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Filter"
        />
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="documents"
        :pagination.sync="pagination"
        :loading="isLoading"
        loading-text="Loading..."
        disable-initial-sort
        :rows-per-page-items="[25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr>
            <td>
              <DateDisplay
                :date="props.item.date_of_creation"
              />
            </td>
            <td>
              {{ props.item.document_type }}
            </td>
            <td>
              {{ props.item.security_name }}
            </td>
            <td>
              {{ props.item.brand }}
            </td>
            <td>
              {{ props.item.investment_mode }}
            </td>
            <td class="text-xs">
              <tr>
                <v-tooltip
                  top
                  dark
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      dark
                      flat
                      icon
                      color="primary"
                      v-on="on"
                      @click.stop="() => downloadDocument(props.item.file_name)"
                    >
                      <v-icon>download</v-icon>
                    </v-btn>
                  </template>
                  <span>Download Document</span>
                </v-tooltip>
              </tr>
              <tr>
                <v-tooltip
                  top
                  dark
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      dark
                      flat
                      icon
                      color="primary"
                      v-on="on"
                      @click.stop="() => recreateDocument(props.item.payout_id,props.item.investment_holder_id)"
                    >
                      <v-icon>refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Recreate Document</span>
                </v-tooltip>
              </tr>
            </td>
          </tr>
        </template>
      </v-data-table>
    </template>

    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColor"
      :auto-height="true"
    >
      <ul v-if="snackbarErrors">
        <li
          v-for="snackbarError in snackbarErrors"
          :key="snackbarError.message"
        >
          {{ snackbarError.message }}
        </li>
      </ul>

      <div
        v-if="snackbarMessage"
      >
        {{ snackbarMessage }}
      </div>

      <v-btn
        color="primary"
        text
        @click="snackbarShow = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>

import { mapActions } from 'vuex';
import DateDisplay from '@/components/payoutsAndTaxes/payout/shared/DateDisplay';
import { SearchItems } from '@/components';
import { base64toBlob, saveFile } from '@/helpers';

export default {
  name: 'Documents',
  components: {
    'search-items': SearchItems,
    DateDisplay,
  },
  data() {
    return {
      user: null,
      documents: null,
      isLoading: false,
      pagination: {
        rowsPerPage: 25,
      },
      snackbarShow: false,
      snackbarMessage: '',
      snackbarColor: 'error',
      snackbarErrors: [],
      search: '',
      headers: [
        { text: 'Created At', value: 'date_of_creation' },
        { text: 'Document Type', value: 'document_type' },
        { text: 'Security Name', value: 'security_name' },
        { text: 'Brand', value: 'brand' },
        { text: 'Investment Mode', value: 'investment_mode' },
        { text: 'Actions', value: 'actions' },
      ],
    };
  },
  methods: {
    ...mapActions(['searchUsers']),
    selectUser(item) {
      this.user = item;
      const { id } = item;

      this.$store.dispatch('fetchPayoutTaxReportsDocumentsByUserId', id).then((documents) => {
        this.documents = documents;
      });
    },
    onEnter(e) {
      const id = this.extractId(e.srcElement._value);
      this.selectUser({
        id,
      });
    },
    extractId(value) {
      if (this.isObject(value)) {
        return value.id;
      }

      return value;
    },
    isObject(value) {
      return typeof value === 'object' && !Array.isArray(value) && value !== null;
    },
    recreateDocument(payoutId, holderId) {
      this.$store
        .dispatch('recreatePdfDocument', {
          payout_id: payoutId,
          holder_id: holderId,
        })
        .then(() => {
          this.snackbarShow = true;
          this.snackbarErrors = [];
          this.snackbarMessage = 'Recreation triggered successfully';
          this.snackbarColor = 'success';
        })
        .catch((error) => {
          this.snackbarShow = true;
          this.snackbarErrors = (error.response && error.response.data) ? error.response.data : 'Error';
          this.snackbarMessage = '';
          this.snackbarColor = 'error';
        });
    },
    downloadDocument(fileName) {
      const data = {
        userId: this.user.id,
        fileName: encodeURIComponent(fileName),
      };

      this.$store
        .dispatch('fetchPayoutTaxReportsDownloadDocumentByUserIdAndFileName', data)
        .then((response) => {
          saveFile(base64toBlob(response.data), `${response.headers['x-file-name']}.pdf`);
        });
    },
  },
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/Documents.vue